import CreateBillingObject from '../Utils/ObjectUtils/CreateBillingObject';
import CreateShippingObject from '../Utils/ObjectUtils/CreateShippingObject';
import FormatDateOfBirthForApiCall from '../Utils/ObjectUtils/FormatDateOfBirthForApiCall';
import GeneratePaymentDetailsObject from '../Utils/ObjectUtils/GeneratePaymentDetailsObject';
import UserPermissionsObject from '../Utils/ObjectUtils/UserPermissionsObject';

function GuestCheckoutAction(
	shippingFormData,
	paymentFormData,
	brandData,
	cartData,
	promoCode,
	bumpCode,
	addon,
	couponCode,
	velocityNumber,
	businessPartner,
	receiveEmail,
	addUnlimitedToCart
) {
	const {
		address1,
		address1Billing,
		address2,
		address2Billing,
		billingSameAsShipping,
		city,
		cityBilling,
		companyName,
		companyNameBilling,
		email,
		firstName,
		firstNameBilling,
		lastName,
		lastNameBilling,
		password,
		phoneNumber,
		phoneNumberBilling,
		postalCode,
		postalCodeBilling,
		salutation,
		state,
		stateBilling,
		stateCode,
		stateCodeBilling,
		dob,
	} = shippingFormData;

	let billingInformation = {
		salutation,
		firstName,
		lastName,
		companyName,
		address1,
		address2,
		phoneNumber,
		city,
		state,
		postalCode,
		stateCode,
	};

	if (!billingSameAsShipping) {
		billingInformation = {
			salutation,
			firstName: firstNameBilling,
			lastName: lastNameBilling,
			companyName: companyNameBilling,
			address1: address1Billing,
			address2: address2Billing,
			phoneNumber: phoneNumberBilling,
			city: cityBilling,
			state: stateBilling,
			postalCode: postalCodeBilling,
			stateCode: stateCodeBilling,
		};
	}

	let paymentDetails = [
		GeneratePaymentDetailsObject(
			billingInformation,
			paymentFormData,
			brandData.country,
			shippingFormData.email
		),
	];

	if (paymentFormData === 'paypal') {
		paymentDetails = [
			{
				billingAddress: CreateBillingObject(
					brandData.country,
					shippingFormData.email,
					billingInformation
				),
				type: 'paypalPayment',
			},
		];
	}

	let shippingDetails = [
		CreateShippingObject(
			brandData.country,
			'hardGoodShippingTypeInput',
			shippingFormData.email,
			shippingFormData
		),
	];

	let userCheckoutPermissions = UserPermissionsObject(receiveEmail);

	let itemDetails = [];

	if (addon) {
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode: addon?.itemCode,
			},
		];
	} else if (cartData) {
		let itemCode = cartData[0].itemCode;
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode,
			},
		];
	}

	if (addUnlimitedToCart) {
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode: addUnlimitedToCart,
			},
		];
	}

	if (bumpCode) {
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode: bumpCode,
			},
		];
	}

	// if (addon) {
	// 	itemDetails = [
	// 		...itemDetails,
	// 		{
	// 			quantity: 1,
	// 			itemCode: addon?.itemCode,
	// 		},
	// 	];
	// }

	let orderDetails = {
		offerDetails: { responseCode: promoCode },
		itemDetails,
		paymentDetails,
		shippingDetails,
		userCheckoutPermissions,
		userCheckoutPreferences: {
			payViaPaypal: paymentFormData === 'paypal' ? true : false,
			payByVouchersOnly: false,
			saveCreditCard: paymentFormData?.addcardtoprofile ?? false,
		},
		webRedirectDetails: {
			commitOrderErrorURL: window.location.href,
			commitOrderSuccessURL: '/jsp/checkout/common/confirmation.jsp?promoCode=',
		},
	};

	if (email) {
		let accountRegistrationPreferences = {
			email,
			password,
			userDateOfBirth: FormatDateOfBirthForApiCall(dob),
		};

		orderDetails = {
			...orderDetails,
			accountRegistrationPreferences,
		};
	}

	// PromoCode, if available
	if (couponCode) {
		let couponDetails = [
			{
				couponCode: couponCode,
			},
		];

		orderDetails = { ...orderDetails, couponDetails };
	}

	// Third Party Number, if available
	if (velocityNumber && businessPartner) {
		let userCheckoutDetails = {
			userBusinessPartner: {
				businessPartner: businessPartner,
				businessPartnerNumber: velocityNumber,
			},
		};

		orderDetails = { ...orderDetails, userCheckoutDetails };
	}

	return orderDetails;
}

export default GuestCheckoutAction;
